import { z } from 'zod';
import { OwnerCornSchema } from '../owner/owner.js';
import { HttpsUrlSchema } from '../util/url.js';
import { WhiteLabelServiceEventBaseSchema, whiteLabelServiceEventType } from './service.js';
const assetEventType = (eventName) => whiteLabelServiceEventType('asset', eventName);
const assetEventMetadata = WhiteLabelServiceEventBaseSchema.shape.metadata.and(z.object({
    requestActor: z.string(),
}));
export const AssetTypeSchema = z.enum(['logo', 'welcomeHeaderImage', 'welcomeButtonLogo']);
export const AssetUpdatedEventSchema = WhiteLabelServiceEventBaseSchema.extend({
    asset: z.object({
        ownerId: OwnerCornSchema,
        assetType: AssetTypeSchema,
        assetKey: z.string().min(1),
        assetUrl: HttpsUrlSchema,
    }),
    metadata: assetEventMetadata,
    type: assetEventType('updated'),
});
